<template>
    <c-app-recent
        icon      = "mdi-timeline-clock"
        :tooltip  = "$t('navtop.recent.site')"
        :loader   = "load"
        @selected = "onSelected"
    >
        <template v-slot:title="{ item }">
            <div>
                Fabrik-Nr. {{ item.recent.site.fabricNo }} - {{ item.recent.site.id }}
            </div>

            <v-spacer />
            <div style="margin-top: -4px; margin-right: -8px;">
                <c-site-icon :color="item.hover ? 'white' : 'primary' " :site="item.recent.site" />
            </div>
        </template>

        <template v-slot:subtitle="{ item }" >
            <div style="margin-top: -4px;">
                {{ item.site.street }}
            </div>
            <div class="v-flex">
                <div>
                    {{ item.site.zip }} {{ item.site.city }}
                </div>
                <v-spacer />
                <div style="float: right; font-size: 8pt; padding-top: 1px">
                    {{ format(item.accesstime) }}
                </div>
            </div>
        </template>
    </c-app-recent>
</template>

<script>

import Core       from "@/modules/core/service/Core";
import Site       from "@/modules/msd/unit/service/Site";
import CAppRecent from "@/modules/core/components/app/CAppRecent";
import CSiteIcon  from "@/modules/msd/unit/components/controlls/CSiteIcon";

export default {
    name: "CAppRecentSite",
    components: {
        CSiteIcon,
        CAppRecent
    },

    data: () => ({
    }),

    methods: {
        load () {
            return Site.recents();
        },

        format (value) {
            return Core.format.datetime.display(value);
        },

        onSelected (item) {
            Site.goto(this, item.site.id);
            this.menuOpen = false;
        },
    }
}
</script>

<style scoped>

.recent-subtitle {
    font-size: 9pt;
    padding-top: 2px;
}

.recent-status {
    border-radius: 2px;
    max-width: 12px;
    min-width: 12px;
    max-height: 12px;
    min-height: 12px;
}

</style>